// AnimatedBackground.js — the site-wide backdrop behind all page content.
// Static on purpose: the old animated, blurred aurora cost real paint time on
// phones (Core Web Vitals). Two soft brand-colour glows give the same feel.
// (Name kept so App.js imports stay stable.)

import React from "react";
import { Box } from "@mui/material";

export default function AnimatedBackground() {
  return (
    <Box
      aria-hidden
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none",
        background: [
          "radial-gradient(900px 600px at 8% -5%, rgba(111,93,245,0.22), transparent 70%)",
          "radial-gradient(800px 600px at 100% 30%, rgba(57,208,255,0.14), transparent 70%)",
          "radial-gradient(700px 500px at 30% 110%, rgba(200,59,212,0.10), transparent 70%)",
        ].join(", "),
      }}
    />
  );
}
